import * as React from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

import SystemMessageWrapperContext from '../../../wrapper/context/SystemMessageWrapperContext';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message-negotiations-reopened-details-other-arrangement.i18n.json'));

import { SystemMessageNegotiationsReopenedDetailsType } from '../../types';

type Props = {
  type: SystemMessageNegotiationsReopenedDetailsType
};

const MSG_KEY = 'system_message_negotiations_reopened_details_other_arrangement';

const SystemMessageNegotiationsReopenedDetailsOtherArrangement: React.FC<Props> = ({
  type
}: Props) => {
  const context = React.useContext(SystemMessageWrapperContext);
  const { message } = context;
  const subcampaign = get(message, 'metadata.subcampaign', {});
  const { offer, updatedOffer } = subcampaign;
  const currentOffer = !isNil(updatedOffer) && type === 'new' ? updatedOffer : offer;
  const label = __t(`${MSG_KEY}.labels.${type}_offer`);

  return (
    <div className="system-message-negotiations-reopened-details-other-arrangement">
      {label}: {currentOffer.perks}
    </div>
  );
};

export default SystemMessageNegotiationsReopenedDetailsOtherArrangement;
